import InputRangeButton from './InputRangeButton';

export default InputRangeButton;
